exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tickets-page .content-tickets-index .ticket-time{font-weight:600}.tickets-page .content-tickets-index .ticket-time--success{color:#2e8b57}.tickets-page .content-tickets-index .ticket-time--warning{color:#d4a017}.tickets-page .content-tickets-index .ticket-time--danger{color:#d64545}", ""]);

// exports
